module.exports = __webpack_public_path__ + "static/media/headMap.e22260ad.png";